var _rect, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboard4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 28,
    viewBox: "0 0 26 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.84973,
    y: 25.8685,
    width: 11.97,
    height: 5.07704,
    rx: 2.53852,
    transform: "rotate(-90 1.84973 25.8685)",
    fill: "white",
    stroke: "#91BDFA",
    strokeWidth: 2.30053
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.7872,
    y: 25.8685,
    width: 24.019,
    height: 5.07704,
    rx: 2.53852,
    transform: "rotate(-90 10.7872 25.8685)",
    fill: "white",
    stroke: "#91BDFA",
    strokeWidth: 2.30053
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 19.947,
    y: 25.6385,
    width: 17.7357,
    height: 4.61693,
    rx: 2.30846,
    transform: "rotate(-90 19.947 25.6385)",
    fill: "#FB7401",
    stroke: "#FB7401",
    strokeWidth: 1.84043
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard4);
export default __webpack_public_path__ + "static/media/Dashboard4.0c5213b04dc7ccde87359f756f1e2058.svg";
export { ForwardRef as ReactComponent };